// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kl-custom-select-container {
  display: block !important;
}
.kl-custom-select-container > .ant-select {
  height: 45px;
}
.kl-custom-select-container > .ant-select .ant-select-dropdown {
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
}
.kl-custom-select-container .ant-select-selector {
  padding: 8px 12px 8px 12px !important;
  display: block;
  height: 100% !important;
}
.kl-custom-select-container .ant-select-single.ant-select-show-arrow .ant-select-selection-item {
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: 0em;
  height: unset !important;
  white-space: normal;
  text-overflow: unset;
}
.kl-custom-select-container .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
  color: #00000080;
  font-size: 14px;
  font-weight: 400;
  line-height: 2;
  letter-spacing: 0em;
  height: unset !important;
  white-space: normal;
  text-overflow: unset;
}
.kl-custom-select-container .ant-select-item-option {
  display: flex;
  text-align: left;
}
.kl-custom-select-container .small .ant-select-selector {
  padding: 3px 0px 3px 18px !important;
  display: block;
  height: 40px !important;
}
.kl-custom-select-container .small .ant-select-selection-placeholder {
  line-height: 30px !important;
  padding-right: 28px;
}
.kl-custom-select-container .small .ant-select-selection-item {
  padding-right: 28px;
}
.kl-custom-select-container .ant-select-selection-search-input {
  height: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/UiComponents/CustomSelect/CustomSelect.less"],"names":[],"mappings":"AAEA;EACE,yBAAA;AADF;AAAA;EAII,YAAA;AADJ;AAHA;EAMM,6BAAA;EACA,kBAAA;EACA,mBAAA;AAAN;AARA;EAaI,qCAAA;EACA,cAAA;EACA,uBAAA;AAFJ;AAbA;EAsBM,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,mBAAA;EACA,oBAAA;AANN;AAvBA;EAgCM,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,mBAAA;EACA,oBAAA;AANN;AAjCA;EA4CI,aAAA;EACA,gBAAA;AARJ;AArCA;EAkDM,oCAAA;EACA,cAAA;EACA,uBAAA;AAVN;AA1CA;EAwDM,4BAAA;EACA,mBAAA;AAXN;AA9CA;EA6DM,mBAAA;AAZN;AAjDA;EAiEI,uBAAA;AAbJ","sourcesContent":["@import url(\"../../../assets/Styles/variables.less\");\n\n.kl-custom-select-container {\n  display: block !important;\n\n  > .ant-select {\n    height: 45px;\n    .ant-select-dropdown {\n      position: absolute !important;\n      left: 0 !important;\n      right: 0 !important;\n    }\n  }\n\n  .ant-select-selector {\n    padding: 8px 12px 8px 12px !important;\n    display: block;\n    height: 100% !important;\n    input {\n    }\n  }\n\n  .ant-select-single.ant-select-show-arrow {\n    .ant-select-selection-item {\n      color: @black-color;\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 1.2;\n      letter-spacing: 0em;\n      height: unset !important;\n      white-space: normal;\n      text-overflow: unset;\n    }\n    .ant-select-selection-placeholder {\n      color: @placeholder;\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 2;\n      letter-spacing: 0em;\n      height: unset !important;\n      white-space: normal;\n      text-overflow: unset;\n    }\n  }\n\n  .ant-select-item-option {\n    display: flex;\n    text-align: left;\n  }\n\n  .small {\n    .ant-select-selector {\n      padding: 3px 0px 3px 18px !important;\n      display: block;\n      height: 40px !important;\n    }\n\n    .ant-select-selection-placeholder {\n      line-height: 30px !important;\n      padding-right: 28px;\n    }\n\n    .ant-select-selection-item {\n      padding-right: 28px;\n    }\n  }\n  .ant-select-selection-search-input {\n    height: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
